// Usuário (vendedor) logado, lido da sessão local. Fonte única — antes estava
// copiado em useFirebase, Caixa, Clientes, FilaImpressao e Pedidos.
export function getUser() {
  try {
    const ls = JSON.parse(localStorage.getItem("3dp_user"));
    const ss = JSON.parse(sessionStorage.getItem("3dp_user"));
    return ls || ss || null;
  } catch {
    return null;
  }
}
